"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowerDetailsSchema = void 0;
var constants_1 = require("../../constants");
exports.borrowerDetailsSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'claimBorrowerCategoryID',
        'claimBorrowerTypeID',
        'defaultReasonCode',
        'financialAssessmentCompletedFlag',
        'firstName',
        'judgmentActionTypeCode',
        'lastName',
    ],
    properties: {
        birthDate: {
            type: ['string', 'null'],
            format: 'date',
            strictlyPastDate: true,
            errorMessage: 'Should be a valid date formatted as yyyy-mm-dd or null',
        },
        claimBorrowerCategoryID: {
            type: 'string',
            enum: Object.values(constants_1.ClaimBorrowerCategory),
            errorMessage: 'Should equate to a valid ClaimBorrowerCategory Enum value',
        },
        claimBorrowerTypeID: {
            type: 'number',
            enum: Object.values(constants_1.ClaimBorrowerType),
            errorMessage: 'Should equate to a valid ClaimBorrowerType Enum value',
        },
        defaultReasonCode: {
            type: 'string',
            enum: Object.values(constants_1.DefaultReason),
            errorMessage: 'Should equate to a valid DefaultReason Enum value',
        },
        financialAssessmentCompletedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be between true or false',
        },
        firstName: {
            type: 'string',
            minLength: 1,
            maxLength: 15,
            errorMessage: 'Should have maximum of 15 characters',
        },
        indexNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 100,
            errorMessage: 'Should be an integer between 0 and 100',
        },
        judgmentActionTypeCode: {
            type: 'string',
            enum: Object.values(constants_1.JudgmentAction),
            errorMessage: 'Should equate to a valid JudgmentAction Enum value',
        },
        lastName: {
            type: 'string',
            minLength: 1,
            maxLength: 20,
            errorMessage: 'Should have maximum of 20 characters',
        },
        otherDefaultReasonDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with maximum of 100 characters or null',
        },
        otherReasonNotPursuedDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with maximum of 100 characters or null',
        },
        reasonNotPursuedTypeCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_1.ReasonNotPursued), [null]),
            errorMessage: 'Should equate to a valid ReasonNotPursued Enum value or null',
        },
    },
};
